import React from "react";
import { Nav } from "react-bootstrap";

import ileeroLogo from "../../../assets/images/ileero-logo-white.png";
import socialMediaContacts from "../../../core/data/social-media-contacts";

const Footer = () => {
  return (
    <div className="bg-primary text-white" id="contact">
      <div className="footer py-5 container-fluid">
        <div className="row justify-content-between m-0">
          <div className="col-xl-4  col-lg-6 col-12">
            <img src={ileeroLogo} alt="" height="35" className="mb-3" />
            <p>
              Ileero Remit enables easy access for people and business to send
              and receive money globally.
            </p>
          </div>
          <div className="col-lg-4 col-12">
            <div className="row">
              <div className="col-lg-6 col-12">
                <h5>Links</h5>
                <p className="cursor-pointer">
                  <Nav.Link className="text-white p-0" href="/about-us">
                    About Us
                  </Nav.Link>
                </p>
                <p className="cursor-pointer">
                  <Nav.Link
                    className="text-white p-0"
                    href="/#choose-ileero-remit"
                  >
                    Features
                  </Nav.Link>
                </p>
                <p className="cursor-pointer">
                  <Nav.Link className="text-white p-0" href="/#faqs">
                    FAQs
                  </Nav.Link>
                </p>
                <p className="cursor-pointer">
                  <Nav.Link
                    className="text-white p-0"
                    href="https://medium.com/@ileeroremit"
                  >
                    Blog
                  </Nav.Link>
                </p>
                <p className="cursor-pointer">
                  <Nav.Link
                    className="text-white p-0"
                    href="/terms-and-conditions"
                  >
                    Terms of Use
                  </Nav.Link>{" "}
                </p>
                <p className="cursor-pointer">
                  <Nav.Link className="text-white p-0" href="/privacy-policy">
                    Privacy Policy
                  </Nav.Link>{" "}
                </p>
                <p className="cursor-pointer">
                  <Nav.Link className="text-white p-0" href="/complaint-policy">
                    Complaint Policy
                  </Nav.Link>{" "}
                </p>
              </div>
              <div className="col-lg-6 col-12">
                <h5>Contact</h5>
                <p>
                  Ileero Pay Limited, No 33 Mountview House, 202-212 High Rd, Ilford IG1 1QB.
                </p>
                <p>info@ileero.com</p>
                <p>+44 20 3011 2409 | +44 800 254 5064</p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between flex-column flex-lg-row px-3">
          <p className="small"> 2022 Ileero Remit. All Right Reserved.</p>
          <SocialMedia />
        </div>
      </div>
    </div>
  );
};

const SocialMedia = () => (
  <>
    <div className="d-flex">
      {socialMediaContacts.map((contact, index) => (
        <div
          className="mr-3 ml-lg-3 cursor-pointer"
          key={index}
          onClick={() => window.open(contact.link, "_blank")}
        >
          <img src={contact.icon} alt={contact.title} />
        </div>
      ))}
    </div>
  </>
);
export default Footer;
